import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

const BTN_INITIAL = { opacity: 0, scale: 0.8, y: 12 };
const BTN_ANIMATE = { opacity: 1, scale: 1, y: 0 };
const BTN_EXIT = { opacity: 0, scale: 0.8, y: 12 };
const BTN_TRANS = { duration: 0.25, ease: [0.22, 1, 0.36, 1] };

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      setVisible(y > 500);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.1 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          onClick={toTop}
          data-testid="scroll-to-top"
          aria-label="Back to top"
          initial={BTN_INITIAL}
          animate={BTN_ANIMATE}
          exit={BTN_EXIT}
          transition={BTN_TRANS}
          className="group fixed bottom-24 right-5 sm:bottom-28 sm:right-7 z-[55] flex h-12 w-12 items-center justify-center rounded-full bg-white text-mobix-navy ring-1 ring-mobix-navy/10 shadow-[0_12px_30px_rgba(11,43,86,0.20)] transition-all duration-300 hover:bg-mobix-navy hover:text-white hover:-translate-y-0.5"
        >
          <ArrowUp size={22} className="transition-transform duration-300 group-hover:-translate-y-0.5" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
